import '../../css/chat/livechats.css';

import React, { Component } from 'react';
import { Col, Row, Form, Button } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { search, sort, selectHistoryIntercation } from '../../redux/interactionsSlice';
import HistoryFilters from './historyfilters';
import Moment from 'react-moment';
import { useNavigate } from "react-router-dom";
import ChatsService from 'src/controllers/ChatController';

class HistoryChats extends Component {

    constructor() {

        super();
        this.state = {
            interactions: [],
            interactionsSearchResult: [],
            dir: "desc",
            showHistoryFilters: false,
            interaction: null,
            searchText: ""
        };
        this.handleSort = this.handleSort.bind(this);
        this.setInteractions = this.setInteractions.bind(this);
        this.toggleFiltersModal = this.toggleFiltersModal.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleChange = e => {
        let searchText = e.target.value,
            arr = this.state.interactions;
        if (arr != null && arr.length > 0 && searchText != null && searchText.length > 0)
            arr = arr.filter(x =>
                (x.name != null && x.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1) ||
                (x.group != null && x.group.toLowerCase().indexOf(searchText.toLowerCase()) > -1) ||
                (x.messages != null && x.messages.length > 0
                    && x.messages.filter(y => y.text.toLowerCase().indexOf(searchText.toLowerCase()) > -1
                        || (y.subject && y.subject.toLowerCase().indexOf(searchText.toLowerCase()) > -1)
                    ).length > 0)
            );

        this.setState({
            searchText: searchText,
            interactionsSearchResult: arr
        });
    }

    handleSort = e => {
        let dir = this.state.dir === "desc" ? "asc" : "desc";
        if (dir === "desc")
            this.state.interactionsSearchResult.sort((a, b) => new Date(b.date) - new Date(a.date));
        else
            this.state.interactionsSearchResult.sort((a, b) => new Date(a.date) - new Date(b.date));

        this.setState({
            dir: dir,
            interactionsSearchResult: this.state.interactionsSearchResult
        });
    }

    setInteractions = interactions => {

        let searchText = this.state.searchText,
            arr = interactions;

        if (arr != null && arr.length > 0 && searchText != null && searchText.length > 0)
            arr = arr.filter(x => x.name.toLowerCase().indexOf(searchText.toLowerCase()) > -1);

        if (this.state.dir === "desc")
            arr.sort((a, b) => new Date(b.date) - new Date(a.date));
        else
            arr.sort((a, b) => new Date(a.date) - new Date(b.date));

        this.setState({
            interactions: interactions,
            interactionsSearchResult: arr
        });

    }

    toggleFiltersModal = e => {
        //e.preventDefault();
        this.setState({ showHistoryFilters: !this.state.showHistoryFilters });
    }

    handleClick(elem) {
        let from = elem.outbound ? elem.to : elem.from;

        ChatsService.findContact({
            bookId: elem.bookId,
            tenantId: elem.tenantId,
            from: from,
            email: elem.email,
            channel: elem.channel,
            name: elem.name,
            guid: elem.guid,
            phone: elem.phone
        }, data => {

            if (data != null && data.length > 0) {
                elem.bookId = data[0].contactId;
                elem.contacts = data
            }

            this.setState({
                interaction: elem
            });

            this.props.selectHistoryIntercation(elem);
        });
    }

    render() {
        let list = <div className=""></div>;

        if (this.state.interactionsSearchResult && this.state.interactionsSearchResult.map) {
            list = this.state.interactionsSearchResult.map(c => {
                let className = "icon " + c.channel,
                    lastMessage = c.messages[c.messages.length - 1];

                return <div key={c.id} id={c.id} elem={c} className={'interaction-item ' + (this.state.interaction && this.state.interaction.id === c.id ? "badge-light-primary" : "")}
                    onClick={e => { e.preventDefault(); this.handleClick(c); }}>
                    <Row>
                        <Col lg={1}><div className={className}
                            style={c.image != null && c.image.trim() !== "" ? { backgroundImage: `url("${c.image}")` } : {}}></div>
                        </Col>
                        <Col lg={2}>
                            <div className={`${!c.outbound ? 'text-success' : 'text-primary'} text-center`}  >
                                {
                                    (c.outbound) &&
                                    <FontAwesomeIcon className='primary' size='2x' icon={duotone('arrow-up-right')} />
                                }
                                {
                                    (!c.outbound) &&
                                    <FontAwesomeIcon className='success' size='2x' icon={duotone('arrow-down-left')} />
                                }
                            </div>
                        </Col>
                        <Col lg={7}>
                            <div className='text-primary'>{c.group}</div>
                            <div className='text-muted'>{c.name}</div>
                            <div className='text-muted last-message'>{lastMessage.text}</div>
                        </Col>

                        <Col lg={2}>
                            <Row><Col><div className='float-end time'><Moment format='DD/MM/yyyy HH:mm'>{c.date}</Moment></div></Col></Row>
                            <Row><Col>{c.unreadMessages != null && c.unreadMessages > 0 ? <div className='float-end unread'>{c.unreadMessages}</div> : null}</Col></Row>
                        </Col>

                    </Row>
                </div>
            });
        }

        return (
            <div>
                <Row className='searchconversations'>
                    <Col xxl={10} lg={8}>
                        <FontAwesomeIcon className='searchicon' icon={solid("magnifying-glass")} />
                        <Form.Control className='searchinput' type="text" placeholder={this.props.t("search")} onChange={this.handleChange}></Form.Control>
                    </Col>
                    <Col xxl={1} lg={2}>
                        <Button variant='light' className='filterbutton' onClick={this.handleSort}>
                            {
                                (this.state.dir === "desc") &&
                                <FontAwesomeIcon icon={solid("arrow-up-wide-short")} />
                            }
                            {
                                (this.state.dir !== "desc") &&
                                <FontAwesomeIcon icon={solid("arrow-down-wide-short")} />
                            }
                        </Button>
                    </Col>
                    <Col xxl={1} lg={2}>
                        <Button variant='light' className='filterbutton' onClick={this.toggleFiltersModal}>
                            <FontAwesomeIcon icon={duotone("filters")} />
                        </Button>
                    </Col>
                </Row>

                {
                    (this.state.interactionsSearchResult && this.state.interactionsSearchResult.length > 0) &&
                    <div className='chatslist'>{list}</div>
                }

                {
                    (!this.state.interactionsSearchResult || this.state.interactionsSearchResult.length === 0) &&

                    <div className='d-flex flex-column flex-center nochats'>
                        <div className="fs-1 text-center">Fidelity</div>
                        <div className="fs-4 text-muted text-center">Conversations not found</div>
                        <div className='nochatsimg'></div>
                    </div>
                }

                <HistoryFilters show={this.state.showHistoryFilters} toggleModal={this.toggleFiltersModal} setInteractions={this.setInteractions}></HistoryFilters>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        interactions: state.interaction.searchResult,
        interaction: state.interaction.current,
        dir: state.interaction.sort
    };
};
function WithNavigate(props) {
    let navigate = useNavigate();
    return <HistoryChats {...props} navigate={navigate} />
}


export default compose(connect(mapStateToProps, { search, sort, selectHistoryIntercation }), withTranslation())(WithNavigate);